import memoize from 'memoize-one';
import { includes, reduce } from 'lodash';

const checkPermission = (pemissions, grantPermissions) => {
  if (typeof pemissions === 'string') {
    return includes(grantPermissions, pemissions);
  }

  return reduce(pemissions, (result, nestedRequiredPermission, operator) => {
    switch (operator) {
      case '$or':
        return reduce(nestedRequiredPermission, (innerResult, currentPermission) =>
          innerResult || checkPermission(currentPermission, grantPermissions), false);
      case '$and':
        return reduce(nestedRequiredPermission, (innerResult, currentPermission) =>
          innerResult && checkPermission(currentPermission, grantPermissions), true);
      default:
        throw Error('unknown operator');
    }
  }, false);
};

export default memoize(checkPermission);



// WEBPACK FOOTER //
// ./src/components/permission/utils/checkPermission.js